module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2d7fc00c9946be668ee303594dfebce0.png";